// extracted by mini-css-extract-plugin
export var dropdown = "_qz-0";
export var imageWrapper = "_qz-3";
export var itemNameContainer = "_qz-1";
export var productImage = "_qz-2";
export var spinnerWrapper = "_qz-4";